export const permissionsCompaniesFull = ["companies-full", "everything-full"];
